// Design Ref: §2.1, §10.4 — 공유 Sentry 설정. client/server hooks에서 import하여 init 시 사용.
import { env } from '$env/dynamic/public';
import { dev } from '$app/environment';

const dsn = env.PUBLIC_SENTRY_DSN;
const release = import.meta.env.VITE_SENTRY_RELEASE;

// Plan SC: 환경 게이팅 — production + DSN 존재 시에만 활성화
export const isSentryEnabled = !dev && Boolean(dsn);

export const sentryConfig = {
	dsn,
	enabled: isSentryEnabled,
	environment: dev ? 'development' : 'production',
	release,
	tracesSampleRate: 0.1,
	sendDefaultPii: false
};
